<ng-container
  *ngFor="
    let item of automationGroups;
    let index = index;
    let first = first;
    let last = last;
    let even = even;
    let odd = odd;
    trackBy: trackByGroupId
  "
>
  <ng-container
    *ngTemplateOutlet="
      $safeNavigationMigration(automationItemDirective?.template);
      context: {
        $implicit: item,
        item: item,
        index: index,
        first: first,
        last: last,
        even: even,
        odd: odd,
        name: name,
        label: label,
        type: type,
        event: event,
        handler: handler
      }
    "
  ></ng-container>
</ng-container>

<ng-container *ngIf="!automationGroups?.length">
  <ng-container
    *ngTemplateOutlet="
      $safeNavigationMigration(automationItemDirective?.template);
      context: {
        $implicit: item,
        item: item,
        index: index,
        first: first,
        last: last,
        even: even,
        odd: odd,
        name: name,
        label: label,
        type: type,
        event: event,
        handler: handler
      }
    "
  ></ng-container>
</ng-container>

<div *ngIf="automationGroups?.length > 0" class="text-right">
  <button class="btn btn-secondary-info" *ngIf="viewType !== 'table'" (click)="onAdd()">
    <i class="far fa-plus"></i> {{ addLabel }}
  </button>
</div>
